import { cn } from '@/util/cn';
import { IWithChildren } from '@/util/reactTypes';

// Two-column body wrapper used by every resort, region, and global
// page that follows the resort chrome pattern. Wraps <Main> + <Side>;
// stacks block-style below lg. Adds 16px horizontal padding on mobile
// so body content doesn't sit hard against the viewport edge — the
// outer containerXlClass only carries 12px, which feels tight on
// phones for tables, images, and wider content blocks. md+ keeps the
// chrome's existing 12px alignment so the body doesn't double-indent
// on tablet and up.

export function Layout({
  children, className,
}: { className?: string } & IWithChildren) {
  return (
    <div className={cn('flex max-lg:block max-md:px-4', className)}>
      {children}
    </div>
  );
}
